module.exports = __webpack_public_path__ + "img/chess_japanchess11.8e39e31c.png";